export default __webpack_public_path__ + "static/CuervoVP-conEscenarioVirtual2c-799e7824d72d549f632a1bf275e7885b.jpg";